import { useState } from "react";

export const useIsloading = (initialValue = true) => {
    const [isloading, setIsloading] = useState(initialValue ?? true);

    return {isloading, setIsloading};
}